import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConnectModule } from '@epicuro-next/addons/connect';
import { AsideMenuModule } from '@epicuro-next/ataraxia/aside-menu';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { BadgeComponent } from '@epicuro-next/ataraxia/badge';
import { AtaraxiaContactsModule } from '@epicuro-next/ataraxia/contacts';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { LanguageSelectorModule } from '@epicuro-next/ataraxia/language-selector';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { RadioGroupModule } from '@epicuro-next/ataraxia/radio-group';
import { SwitchesModule } from '@epicuro-next/ataraxia/switches';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { CBASKET_NAMESPACE } from '@epicuro-next/data/baskets';
import { AccountsSelectorModule } from '@epicuro-next/features/accounts-selector';
import { FeatureBasketManagerModule } from '@epicuro-next/features/basket-manager';
import { OnboardingModule } from '@epicuro-next/features/onboarding';
import { FeaturesUploadBasketModule } from '@epicuro-next/features/upload-basket';
import {
  ConfigurationModule,
  NAMESPACE_CONNECT,
} from '@epicuro-next/platform/configuration';
import { StorageModule } from '@epicuro-next/platform/storage';
import { ConnectStateModule } from '@epicuro-next/state/connect-state';
import { OnboardingStateModule } from '@epicuro-next/state/onboarding';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { UserUiStateModule } from '@epicuro-next/state/user-ui-state';
import { StoreModule } from '@ngrx/store';
import { DataContactsModule } from 'libs/data/contacts/src';
import { TranslatePasswordValidationsPipe } from 'password-validations';

import { AssortmentManagerComponent } from './assortment-manager/assortment-manager.component';
import { BusinessContactsComponent } from './business-contacts/business-contacts/business-contacts.component';
import { SearchableBusinessContactsComponent } from './business-contacts/searchable-business-contacts/searchable-business-contacts.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EnablingFeatureModalComponent } from './enabling-feature-modal/enabling-feature-modal.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { MenuRouteWrapperComponent } from './menu-route-wrapper/menu-route-wrapper.component';
import { QuickSettingsComponent } from './quick-settings/quick-settings.component';
import { UserMenuRouterService } from './service/user-menu-router.service';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserMenuWidgetComponent } from './user-menu-widget/user-menu-widget.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { VmiDdrDownloadModalComponent } from './vmi-ddr-download-modal/vmi-ddr-download-modal.component';

@NgModule({
  declarations: [
    UserMenuComponent,
    QuickSettingsComponent,
    LanguageSelectorComponent,
    UserMenuWidgetComponent,
    MenuRouteWrapperComponent,
    ChangePasswordComponent,
    UserDetailsComponent,
    AssortmentManagerComponent,
    EnablingFeatureModalComponent,
    BusinessContactsComponent,
    SearchableBusinessContactsComponent,
  ],
  imports: [
    ReactiveFormsModule,
    ModalModule,
    CommonModule,
    UserStateModule,
    StoreModule,
    LanguageSelectorModule,
    IconsModule,
    AvatarModule,
    AsideMenuModule,
    RouterModule,
    AccountsSelectorModule,
    StorageModule,
    SwitchesModule,
    RadioGroupModule,
    ReactiveFormsModule,
    UserUiStateModule,
    ConnectStateModule,
    ConfigurationModule.forFeature([NAMESPACE_CONNECT, CBASKET_NAMESPACE]),
    ConnectModule,
    FeatureBasketManagerModule,
    FeaturesUploadBasketModule,
    OnboardingModule,
    OnboardingStateModule,
    ClipboardModule,
    TooltipDirective,
    AtaraxiaContactsModule,
    DataContactsModule,
    BadgeComponent,
    VmiDdrDownloadModalComponent,
    TranslatePasswordValidationsPipe,
  ],
  providers: [UserMenuRouterService],
  exports: [UserMenuWidgetComponent],
})
export class UserMenuModule {}
